import { Button } from "@mui/material";
import { Typography } from "@platform/design-system";

import { DropzoneFileItem } from "../../types";
import { formatBytes, formatDate } from "../../util";

import type { JSX } from "react";

type Props = {
  file: DropzoneFileItem;
  downloadDisabled?: boolean;
  onFileDownload?: VoidFunction;
};

const FileInfo = ({
  file,
  downloadDisabled = false,
  onFileDownload,
}: Props): JSX.Element => (
  <Button
    data-testid="ds-file-info"
    variant="text"
    fullWidth
    sx={{
      textTransform: "none",
      alignItems: "flex-start",
      padding: 0,
      flexDirection: "column",
      ":hover": {
        backgroundColor: "transparent",
      },
    }}
    disabled={downloadDisabled}
    onClick={onFileDownload}
  >
    <Typography variant="body-large" sx={{ wordBreak: "break-all" }}>
      {file.name}
    </Typography>
    <Typography variant="body-medium" color="textSecondary">
      <strong>{`${formatBytes(file.size)} ${file?.createdAt ? `• uploaded ${formatDate(file.createdAt)}` : ""}`}</strong>
    </Typography>
  </Button>
);

export default FileInfo;
